import { IDataStorage } from '../internal/data-storage';
import { InternalIndex } from '../internal/internal-index';
import { InternalTable } from '../internal/internal-table';

export class TheatrePatient implements IDataStorage {
  Index: InternalIndex = new InternalIndex('Id', 'Id', true, false);
  tableDefinition: InternalTable = new InternalTable('TheatrePatient', 'Id', true, [this.Index]);

  Id: number;
  PatientId: number;
  CaseNumber: string;
  StartDate: Date;
  EndDate: Date;
  OperatingStartDate: Date;
  OperatingEndDate: Date;
  TimeInOperatingRoomSeconds: number;
  TimeInRecoveryRoomSeconds: number;
  OperatingRoomTimerRunning: boolean;
  PatientStatus: string;
  PhysicalLocationId: number;
  Name: string;
  DoctorIds: number[];
  AnaesthetistIds: number[];
  ProcedureIds: number[];
  OperatingRoomNumber: number;
  OperatingRoomName: string;
  FreeTextProcedure: string;
  MedicalAidDescription: string;
  ProcedureTypeId: number;
  ProcedureType: string;

  static getTableDefinition(): InternalTable {
    return new TheatrePatient().tableDefinition;
  }
}
